'use strict';

var util = angular.module('gymsystem.util');

util.factory('Setting', ['$http', 'server', function($http, server) {
    var self = {};

    self.set = function(name, value) {
        return server.post2('/api/utils/setting/set', {
            name: name,
            value: value
        });
    };

    self.get = function(name) {
        return server.post2('/api/utils/setting/get', {
            name: name
        });
    };

    return self;
}]);
